import React from 'react';

import { createIcon } from '@chakra-ui/react';

export const CollectionIcon = createIcon({
  displayName: 'CollectionIcon',
  viewBox: '0 0 20 20',
  path: (
    <>
      <path
        clipRule="evenodd"
        d="M1.66602 5.41667C1.66602 4.26607 2.59876 3.33333 3.74935 3.33333C4.20959 3.33333 4.58268 3.70643 4.58268 4.16667C4.58268 4.6269 4.20959 5 3.74935 5C3.51923 5 3.33268 5.18655 3.33268 5.41667V14.5833C3.33268 14.8135 3.51923 15 3.74935 15C4.20959 15 4.58268 15.3731 4.58268 15.8333C4.58268 16.2936 4.20959 16.6667 3.74935 16.6667C2.59876 16.6667 1.66602 15.7339 1.66602 14.5833V5.41667Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M18.3327 14.5833C18.3327 15.7339 17.3999 16.6667 16.2493 16.6667C15.7891 16.6667 15.416 16.2936 15.416 15.8333C15.416 15.3731 15.7891 15 16.2493 15C16.4795 15 16.666 14.8135 16.666 14.5833L16.666 5.41667C16.666 5.18655 16.4795 5 16.2493 5C15.7891 5 15.416 4.6269 15.416 4.16667C15.416 3.70643 15.7891 3.33333 16.2493 3.33333C17.3999 3.33333 18.3327 4.26607 18.3327 5.41667L18.3327 14.5833Z"
        fill="currentColor"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M4.99935 4.16667C4.99935 3.24619 5.74554 2.5 6.66602 2.5H13.3327C14.2532 2.5 14.9993 3.24619 14.9993 4.16667V15.8333C14.9993 16.7538 14.2532 17.5 13.3327 17.5H6.66602C5.74554 17.5 4.99935 16.7538 4.99935 15.8333V4.16667ZM13.3327 4.16667H6.66602V15.8333H13.3327V4.16667Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </>
  ),
});
